export default __webpack_public_path__ + "static/media/UR.dff648d3.svg";